
export const domainConstants = {
    theOpen: 'TheOpen',
    womensOpen: 'WomensOpen',
};
